import React, { useEffect, useState } from "react";
import {
  Button,
  Container,
  Content,
  Header,
  Loader,
  CheckPicker,
  DatePicker,
} from "rsuite";
import { Form, Field, FormSpy } from "react-final-form";
import { render } from "react-dom";
import { ContractServices } from "../../../core/services/ContractServices";
import { HelperServices } from "../../../core/services/HelperServices";
import { StoreServices } from "../../../core/services/StoreServices";
import "./Contract.css";
import { Link, useNavigate, useParams } from "react-router-dom";
import { get } from "lodash/fp";
import { UtilityServices } from "../../../core/services/UtilityServices";
import { useSelector } from "react-redux";
import CustomSelector from "../../shared/customSelector";
import { useTranslation } from "react-i18next";
import useDecryptedParams from "../../../navigation/useDecryptParams";
import {
  messageTypeArr,
  roleTypeArr,
  yesNoObjArr,
  dateFormatObj,
  contractTypeObjArr,
  paymentFrequencyObjArr,
  contractForObjArr,
  statusArr,
} from "../../../core/config/AppConstants";
import { ContentRoutes } from "../../../navigation/NavConstant";
import {
  addLabelValue,
  calenderDateToDB,
  dbDateToCalender,
  isEmptyVal,
  isNotEmpty,
  isNotNull,
} from "../../../utils/helpers";
import { ContractFields } from "./ContractDataTypes";
import moment from "moment";
import FileUpload from "../../components/Elements/FileUpload";
function Contract() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [errorMessage, setErrorMessage] = useState("");
  const [loader, setLoading] = useState(false);
  const params: any = useParams();
  const company = useSelector((state: any) => state.company);
  const [fileFetched, setFileFetched] = useState(false);
  const [fileUrl, setFileUrl] = useState<string>();
  const [contractFileName, setContractFileName] = useState<string>("");
  const [file, setFile] = useState<any>(null);
  const [licenseList, setLicenseList] = useState([]);
  const [formData, setFormData] = useState<any>({
    company_id: "",
    contract_from: "",
    contract_to: "",
    contract_billing_rate: "",
    contract_remarks: "",
    music_licenses: "",
    is_internal_ad_allowed: "",
    is_external_ad_allowed: "",
    bill_payment_frequency: "",
    client_contract_type: "",
    contract_for: "",
    automate_bill: "",
    po_number: "",
    agreement_number: "",
    status: statusArr.active,
  });
  let [decryptedParams] = useDecryptedParams(params);

  async function init() {
    try {
      if (decryptedParams.id) {
        setFileFetched(false);
        const response: any = await ContractServices.viewContract(
          +decryptedParams.id
        );
        const respData = get("data.data", response);
        const keyMapper: any = {};

        let obj = { ...formData };
        if (respData?.contract_file_url) {
          setFileUrl(respData?.contract_file_url);
        }
        if (respData?.contract_file) {
          setContractFileName(respData?.contract_file);
        }

        let keyMapperIndex = Object.keys(keyMapper);
        Object.keys(obj).map((formKeys) => {
          if (keyMapperIndex.includes(formKeys)) {
            obj[formKeys] = respData[keyMapper[formKeys]];
          } else if (formKeys === "contract_from") {
            obj["contract_from"] = isEmptyVal(respData["contract_from"])
              ? null
              : dbDateToCalender(respData["contract_from"]);
          } else if (formKeys === "contract_to") {
            obj["contract_to"] = isEmptyVal(respData["contract_to"])
              ? null
              : dbDateToCalender(respData["contract_to"]);
          } else if (
            ["is_internal_ad_allowed", "is_external_ad_allowed"].includes(
              formKeys
            )
          ) {
            obj[formKeys] = respData[formKeys].toString();
          } else if (respData[formKeys]) {
            obj[formKeys] = respData[formKeys];
          }
        });
        setFormData({ ...obj });
      }
    } catch (error: any) {
      UtilityServices.showToaster({
        message: error?.message,
        type: messageTypeArr.error,
      });
      navigate(ContentRoutes.CONTRACTS);
    } finally {
      setFileFetched(true);
    }
  }

  useEffect(() => {
    init();
  }, [decryptedParams.id]);

  useEffect(() => {
    getLicenseList();
  }, []);

  async function getLicenseList() {
    try {
      let params: any = {};
      setLoading(true);
      const res = await HelperServices.getAllValidLicenses(params);
      const licenseArr = addLabelValue(
        get("data.data", res),
        "license_name",
        "id"
      );
      setLicenseList(licenseArr);
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  }

  async function saveContract(form: any, id?: number) {
    try {
      setLoading(true);
      let response: any;
      if (id) {
        response = await ContractServices.updateContract(+id, form);
      } else {
        response = await ContractServices.createContract(form);
      }
      setLoading(false);
      UtilityServices.showToaster({
        message: response?.data?.message,
      });
      navigate(ContentRoutes.CONTRACTS);
    } catch (error: any) {
      setLoading(false);
      UtilityServices.showToaster({
        message: error?.message,
        type: messageTypeArr.error,
      });
      setErrorMessage(error?.message);
    }
  }

  const handleDateChange = (date: any, frmIndex: any) => {
    let frmObj = { ...formData };
    frmObj[frmIndex as keyof typeof frmObj] = date;
    setFormData({ ...frmObj });
  };

  function getCompanyId() {
    let compId = null;
    if (UtilityServices.getLoggedInUser("user_type") === roleTypeArr.client) {
      compId = UtilityServices.getLoggedInUser("company_id");
    } else if (company?.id) {
      compId = company.id;
    }
    return compId;
  }

  const onSubmit = (val: any) => {
    const form = new FormData();
    for (var key in formData) {
      if (key == "contract_from") {
        form.append("contract_from", calenderDateToDB(val[key]));
      } else if (key == "contract_to") {
        form.append("contract_to", calenderDateToDB(val[key]));
      } else if (isNotNull(val[key])) {
        form.append(key, val[key]);
      }
    }
    if (file) {
      form.append("contract_file", file, file.name);
    }
    if (!getCompanyId() && !decryptedParams.id) {
      UtilityServices.showToaster({
        type: "warning",
        message: t("PLEASE_SELECT_FIELD", {
          field: t("COMPANY").toLowerCase(),
        }),
      });
      return;
    }
    if (decryptedParams.id) {
      saveContract(form, decryptedParams.id);
    } else {
      form.set("company_id", getCompanyId());
      saveContract(form);
    }
  };

  return (
    <div className="contract">
      {loader && (
        <Loader
          style={{ zIndex: 9999 }}
          size="lg"
          content="Loading..."
          center
          backdrop={true}
        />
      )}
      <Container className="container">
        <Header className="header mb-2">
          <h4>
            {decryptedParams.id ? t("UPDATE") : t("CREATE")} {t("CONTRACT")}
          </h4>
        </Header>
        <Content className="content contract-create-wrap">
          <Form
            onSubmit={onSubmit}
            validate={(values: any) => {
              const errors: any = {};
              if (!values.contract_from) {
                errors.contract_from = t("REQUIRED", {
                  field:
                    t("START").toLowerCase() + " " + t("DATE").toLowerCase(),
                });
              }
              if (!values.contract_to) {
                errors.contract_to = t("REQUIRED", {
                  field: t("END").toLowerCase() + " " + t("DATE").toLowerCase(),
                });
              }
              if (
                values.contract_from &&
                values.contract_to &&
                new Date(values.contract_to) < new Date(values.contract_from)
              ) {
                errors.contract_to = t(
                  "DATE2_SHALL_BE_GREATER_THAN_EQUAL_DATE1",
                  {
                    date2:
                      t("END").toLowerCase() + " " + t("DATE").toLowerCase(),
                    date1:
                      t("START").toLowerCase() + " " + t("DATE").toLowerCase(),
                  }
                );
              }

              if (!values.client_contract_type) {
                errors.client_contract_type = t("REQUIRED_SELECT", {
                  field:
                    t("CONTRACT").toLowerCase() + " " + t("TYPE").toLowerCase(),
                });
              }
              if (!values.contract_billing_rate) {
                errors.contract_billing_rate = t("REQUIRED", {
                  field:
                    t("BILLING").toLowerCase() + " " + t("RATE").toLowerCase(),
                });
              }
              if (
                values.contract_billing_rate &&
                values.contract_billing_rate < 0
              ) {
                errors.contract_billing_rate = t("VALID", {
                  entity:
                    t("BILLING").toLowerCase() + " " + t("RATE").toLowerCase(),
                });
              }
              if (!values.bill_payment_frequency) {
                errors.bill_payment_frequency = t("REQUIRED_SELECT", {
                  field:
                    t("PAYMENT").toLowerCase() +
                    " " +
                    t("FREQUENCY").toLowerCase(),
                });
              }
              if (!values.automate_bill) {
                errors.automate_bill = t("REQUIRED_SELECT", {
                  field:
                    t("AUTOMATE").toLowerCase() + " " + t("BILL").toLowerCase(),
                });
              }
              if (!values.contract_for) {
                errors.contract_for = t("REQUIRED_SELECT", {
                  field:
                    t("CONTRACT").toLowerCase() + " " + t("FOR").toLowerCase(),
                });
              }
              if (!values.contract_for) {
                errors.contract_for = t("REQUIRED_SELECT", {
                  field:
                    t("CONTRACT").toLowerCase() + " " + t("FOR").toLowerCase(),
                });
              }
              if (!values.is_internal_ad_allowed) {
                errors.is_internal_ad_allowed = t("REQUIRED_SELECT", {
                  field:
                    t("INTERNAL").toLowerCase() + " " + t("AD").toLowerCase(),
                });
              }
              if (!values.is_external_ad_allowed) {
                errors.is_external_ad_allowed = t("REQUIRED_SELECT", {
                  field:
                    t("EXTERNAL").toLowerCase() + " " + t("AD").toLowerCase(),
                });
              }

              return errors;
            }}
            initialValues={{ ...formData }}
            render={({ handleSubmit, form }) => (
              <>
                <FormSpy
                  subscription={{ values: true }}
                  onChange={({ values }) => setFormData(values)}
                />
                <form onSubmit={handleSubmit}>
                  <div className="form-part">
                    {fileFetched && (
                      <FileUpload
                        name="cnt_file"
                        file={file}
                        setFile={setFile}
                        fileUrl={fileUrl}
                        prevName={contractFileName}
                        label={
                          t("UPLOAD") + " " + t("CONTRACT") + " " + t("FILE")
                        }
                        accept={".pdf"}
                      />
                    )}
                    <div className="flex-container">
                      <Field name="contract_from">
                        {({ input, meta }) => (
                          <div className="flex-item">
                            <label>
                              {t("CONTRACT")} {t("START")} {t("DATE")}
                            </label>
                            <DatePicker
                              value={input.value || null}
                              format={dateFormatObj.calendar_d_m_y}
                              name="contract_from"
                              id="contract_from"
                              onChange={(e: any) => {
                                form.change("contract_from", e);
                                handleDateChange(e, "contract_from");
                                input.onChange(e);
                              }}
                              onClean={(event: any) => {
                                form.change("contract_from", "");
                                handleDateChange("", "contract_from");
                                input.onChange("");
                              }}
                            />
                            {meta.error && meta.touched && (
                              <span>{meta.error}</span>
                            )}
                          </div>
                        )}
                      </Field>
                      <Field name="contract_to">
                        {({ input, meta }) => (
                          <div className="flex-item">
                            <label>
                              {t("CONTRACT")} {t("END")} {t("DATE")}
                            </label>
                            <DatePicker
                              value={input.value || null}
                              format={dateFormatObj.calendar_d_m_y}
                              name="contract_to"
                              id="contract_to"
                              onChange={(e: any) => {
                                form.change("contract_to", e);
                                handleDateChange(e, "contract_to");
                                input.onChange(e);
                              }}
                              onClean={(event: any) => {
                                form.change("contract_to", "");
                                handleDateChange("", "contract_to");
                                input.onChange("");
                              }}
                            />
                            {meta.error && meta.touched && (
                              <span>{meta.error}</span>
                            )}
                          </div>
                        )}
                      </Field>
                      <Field name="po_number">
                        {({ input, meta }) => (
                          <div className="flex-item">
                            <label>
                              {t("PO")} {t("NUMBER")}
                            </label>
                            <input {...input} type="text" />
                            {meta.error && meta.touched && (
                              <span>{meta.error}</span>
                            )}
                          </div>
                        )}
                      </Field>
                      <Field name="agreement_number">
                        {({ input, meta }) => (
                          <div className="flex-item">
                            <label>
                              {t("AGREEMENT")} {t("NUMBER")}
                            </label>
                            <input {...input} type="text" />
                            {meta.error && meta.touched && (
                              <span>{meta.error}</span>
                            )}
                          </div>
                        )}
                      </Field>
                      <Field name="client_contract_type">
                        {({ input, meta }) => (
                          <div className="flex-item">
                            <CustomSelector
                              loaderMsg={null}
                              isRequired={true}
                              valueKey="value"
                              labelKey="label"
                              labelName={t("CONTRACT") + " " + t("TYPE")}
                              defaultValue={input.value}
                              onClear={(event: any) => {
                                form.change("client_contract_type", "");
                              }}
                              listData={contractTypeObjArr}
                              onSelect={(e: any, selectedObj: any) => {
                                form.change("client_contract_type", e);
                              }}
                            />
                            {meta.error && meta.touched && (
                              <span>{meta.error}</span>
                            )}
                          </div>
                        )}
                      </Field>
                    </div>
                    <div className="flex-container">
                      <Field name="contract_billing_rate">
                        {({ input, meta }) => (
                          <div className="flex-item">
                            <label>
                              {t("BILLING")} {t("RATE")}*
                            </label>
                            <input
                              {...input}
                              type="number"
                              autoComplete="off"
                              min="0"
                            />
                            {meta.error && meta.touched && (
                              <span>{meta.error}</span>
                            )}
                          </div>
                        )}
                      </Field>
                      <Field name="bill_payment_frequency">
                        {({ input, meta }) => (
                          <div className="flex-item">
                            <CustomSelector
                              loaderMsg={null}
                              isRequired={true}
                              valueKey="value"
                              labelKey="label"
                              labelName={t("PAYMENT") + " " + t("FREQUENCY")}
                              defaultValue={input.value}
                              onClear={(event: any) => {
                                form.change("bill_payment_frequency", "0");
                              }}
                              listData={paymentFrequencyObjArr}
                              onSelect={(e: any, selectedObj: any) => {
                                form.change("bill_payment_frequency", e);
                              }}
                            />
                            {meta.error && meta.touched && (
                              <span>{meta.error}</span>
                            )}
                          </div>
                        )}
                      </Field>
                      <Field name="automate_bill">
                        {({ input, meta }) => (
                          <div className="flex-item">
                            <CustomSelector
                              loaderMsg={null}
                              isRequired={true}
                              valueKey="value"
                              labelKey="label"
                              labelName={t("AUTOMATE") + " " + t("BILL")}
                              defaultValue={input.value}
                              onClear={(event: any) => {
                                form.change("automate_bill", "0");
                              }}
                              listData={yesNoObjArr}
                              onSelect={(e: any, selectedObj: any) => {
                                form.change("automate_bill", e);
                              }}
                            />
                            {meta.error && meta.touched && (
                              <span>{meta.error}</span>
                            )}
                          </div>
                        )}
                      </Field>
                      <Field name="contract_for">
                        {({ input, meta }) => (
                          <div className="flex-item">
                            <label>
                              {t("CONTRACT")} {t("FOR")}*
                            </label>
                            <CheckPicker
                              sticky
                              onChange={(e: any) => {
                                let cFor = e.filter(isNotEmpty);
                                if (e.length) {
                                  form.change("contract_for", cFor.toString());
                                } else {
                                  form.change("contract_for", "");
                                }
                              }}
                              onClean={() => {
                                form.change("contract_for", "");
                              }}
                              data={contractForObjArr}
                              value={input?.value?.toString().split(",")}
                            />
                            {meta.error && meta.touched && (
                              <span>{meta.error}</span>
                            )}
                          </div>
                        )}
                      </Field>
                      <Field name="music_licenses">
                        {({ input, meta }) => (
                          <div className="flex-item">
                            <label>
                              {t("MUSIC")} {t("LICENSE")}
                            </label>
                            <CheckPicker
                              sticky
                              onChange={(e: any) => {
                                let cFor = e.filter(isNotEmpty);
                                if (e.length) {
                                  form.change(
                                    "music_licenses",
                                    cFor.toString()
                                  );
                                } else {
                                  form.change("music_licenses", "");
                                }
                              }}
                              onClean={() => {
                                form.change("music_licenses", "");
                              }}
                              data={licenseList}
                              value={input?.value?.toString().split(",")}
                            />
                            {meta.error && meta.touched && (
                              <span>{meta.error}</span>
                            )}
                          </div>
                        )}
                      </Field>
                    </div>
                    <div className="flex-container">
                      <Field name="is_internal_ad_allowed">
                        {({ input, meta }) => (
                          <div className="flex-item">
                            <CustomSelector
                              loaderMsg={null}
                              isRequired={true}
                              valueKey="value"
                              labelKey="label"
                              labelName={
                                t("INTERNAL") +
                                " " +
                                t("AD") +
                                " " +
                                t("ALLOWED")
                              }
                              defaultValue={input.value}
                              onClear={(event: any) => {
                                form.change("is_internal_ad_allowed", "0");
                              }}
                              listData={yesNoObjArr}
                              onSelect={(e: any, selectedObj: any) => {
                                form.change("is_internal_ad_allowed", e);
                              }}
                            />
                            {meta.error && meta.touched && (
                              <span>{meta.error}</span>
                            )}
                          </div>
                        )}
                      </Field>
                      <Field name="is_external_ad_allowed">
                        {({ input, meta }) => (
                          <div className="flex-item">
                            <CustomSelector
                              loaderMsg={null}
                              isRequired={true}
                              valueKey="value"
                              labelKey="label"
                              labelName={
                                t("EXTERNAL") +
                                " " +
                                t("AD") +
                                " " +
                                t("ALLOWED")
                              }
                              defaultValue={input.value}
                              onClear={(event: any) => {
                                form.change("is_external_ad_allowed", "0");
                              }}
                              listData={yesNoObjArr}
                              onSelect={(e: any, selectedObj: any) => {
                                form.change("is_external_ad_allowed", e);
                              }}
                            />
                            {meta.error && meta.touched && (
                              <span>{meta.error}</span>
                            )}
                          </div>
                        )}
                      </Field>
                      <Field name="contract_remarks">
                        {({ input, meta }) => (
                          <div className="flex-item">
                            <label>
                              {t("CONTRACT")} {t("REMARKS")}
                            </label>
                            <textarea
                              {...input}
                              autoComplete="off"
                              rows={5}
                              cols={30}
                            />
                            {meta.error && meta.touched && (
                              <span>{meta.error}</span>
                            )}
                          </div>
                        )}
                      </Field>
                    </div>
                  </div>

                  <div className="create-action d-flex flex-end">
                    <Link to={ContentRoutes.CONTRACTS}>
                      <Button appearance="primary" color="red" type="button">
                        {t("CANCEL")}
                      </Button>
                    </Link>
                    <Button appearance="primary" color="green" type="submit">
                      {decryptedParams.id ? t("UPDATE") : t("CREATE")}
                    </Button>
                    <Button
                      appearance="default"
                      type="reset"
                      onClick={() => {
                        // review comment: move to new function
                        form.reset();
                        setFile("");
                      }}
                    >
                      {t("RESET")}
                    </Button>
                  </div>
                </form>
              </>
            )}
          />
        </Content>
      </Container>
    </div>
  );
}

export default Contract;
